module.exports = __webpack_public_path__ + "img/new-search.2d031144.svg";